export function MinuteErrorMessage(props) {
  const emissoraOK = () => {
    props.setShowError(false);
  };

  return (
    <div className="showErrorDiv">
      <div className="errorDiv">
        <div className="errorDivSecond">
          <h1>Erro</h1>
          <p style={{ color: "white" }}>{props.infoError}</p>
          <button onClick={emissoraOK} className="buttonOk">
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
